import React, { useState, useEffect } from 'react';
import { fetchImages } from '../../services/api'; // Your API function
import 'bootstrap/dist/css/bootstrap.min.css';

const ArLatestImages = () => {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [showModal, setShowModal] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    // Helper to extract image URL from description HTML
    const extractImageUrl = (htmlString) => {
        const match = htmlString.match(/<img\s+src="([^"]+)"/);
        return match ? match[1] : null;
    };

    useEffect(() => {
        const getImages = async () => {
            setLoading(true);
            try {
                const fetchedImages = await fetchImages('ar'); // Fetch Arabic images
                const publishedImages = fetchedImages
                    .filter(img => img.status === 1)
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

                setImages(publishedImages.slice(0, 10));

            } catch (err) {
                setError('Failed to fetch images');
            } finally {
                setLoading(false);
            }
        };
        getImages();
    }, []);

    if (loading) return <div className="text-center mt-5 fw-bold">Loading images...</div>;
    if (error) return <div className="text-center mt-5 text-danger">{error}</div>;
    if (images.length === 0) return null;

    const openModal = index => {
        setCurrentIndex(index);
        setShowModal(true);
    };

    const closeModal = () => setShowModal(false);
    const prevImage = () => setCurrentIndex((currentIndex - 1 + images.length) % images.length);
    const nextImage = () => setCurrentIndex((currentIndex + 1) % images.length);

    return (
        <div className="latest-images mt-5 text-center">
            <h2 className="fw-bold">صور |</h2>
            <div className="d-flex gap-3 mt-3" style={{ transform: 'scale(0.9)', transformOrigin: 'top left' }}>
                {/* Left large image */}
                {images[0] && (
                    <div
                        style={{ flex: 2, cursor: 'pointer' }}
                        onClick={() => openModal(0)}
                    >
                        <img
                            src={extractImageUrl(images[0].description)}
                            alt={images[0].title}
                            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                        />
                    </div>
                )}

                {/* Right stacked column */}
                <div className="d-flex flex-column gap-3" style={{ flex: 1 }}>
                    {images.slice(1, 4).map((img, idx) => (
                        <div
                            key={img.id}
                            className="position-relative"
                            style={{ flex: 1, cursor: 'pointer' }}
                            onClick={() => openModal(idx + 1)}
                        >
                            <img
                                src={extractImageUrl(img.description)}
                                alt={img.title}
                                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                            />
                            {/* Overlay on the last image */}
                            {idx === 2 && images.length > 4 && (
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: '8px',
                                }}>
                                    <span style={{ color: 'white', fontWeight: 'bold', fontSize: '2rem' }}>
                                        +{images.length - 4}
                                    </span>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>

            {/* Fullscreen Modal */}
            {showModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0,0,0,0.9)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1050,
                }}>
                    {/* Close button */}
                    <button
                        onClick={closeModal}
                        style={{
                            position: 'absolute',
                            top: '20px',
                            right: '20px',
                            fontSize: '2.5rem',
                            color: 'white',
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                        }}
                    >
                        &times;
                    </button>

                    {/* Left arrow */}
                    <button
                        onClick={prevImage}
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '20px',
                            transform: 'translateY(-50%)',
                            fontSize: '4rem',
                            color: 'white',
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                        }}
                    >
                        ‹
                    </button>

                    {/* Right arrow */}
                    <button
                        onClick={nextImage}
                        style={{
                            position: 'absolute',
                            top: '50%',
                            right: '20px',
                            transform: 'translateY(-50%)',
                            fontSize: '4rem',
                            color: 'white',
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                        }}
                    >
                        ›
                    </button>

                    {/* Image */}
                    <img
                        src={extractImageUrl(images[currentIndex].description)}
                        alt={images[currentIndex].title}
                        style={{ maxWidth: '90%', maxHeight: '80%' }}
                    />
                </div>
            )}
        </div>
    );
};

export default ArLatestImages;